import { gql } from "@apollo/client";
import { VendorNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const VENDOR_KEY = "__VENDOR_KEY__";

export const CurrentVendorQuery = gql`
  ${VendorNoNestingFragment}
  query CurrentVendor {
    currentVendor {
      featureFlags {
        code
        enabled
      }
      ...VendorNoNesting
    }
  }
`;

export const UpdateVendorDetailsMutation = gql`
  ${VendorNoNestingFragment}
  mutation UpdateCurrentVendorDetails($input: UpdateVendorDetailsInput!) {
    updateCurrentVendorDetails(input: $input) {
      featureFlags {
        code
        enabled
      }
      ...VendorNoNesting
    }
  }
`;
